export default {
  expirationDateLabel: {
    id: 'step_description_mobile_plan_end_date_label',
    defaultMessage: "Offre flash jusqu'au {endDate, date}.",
  },
}
